import React from 'react';

export default function IncompleteStep() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="11.5" fill="#EEEEEE" stroke="#373737" />
    </svg>
  );
}
